"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _app = require("@package/app");

var _numeral = _interopRequireDefault(require("@package/numeral"));

var _functionalButton = require("@widget/functional-button");

var _storybook = require("@pikassa/storybook");

var _reactRedux = require("react-redux");

var _useDebouncedEffect = require("use-debounced-effect");

var _react = _interopRequireWildcard(require("react"));

var _reduxForm = require("redux-form");

var _useGetAvailableBuyAccount = _interopRequireDefault(require("../hooks/useGetAvailableBuyAccount"));

var _useGetAvailableSellAccount = _interopRequireDefault(require("../hooks/useGetAvailableSellAccount"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var BUY_DIRECTION = 'buy';
var SELL_DIRECTION = 'sell';

function useGetDefaultAccount(accounts) {
  return (0, _react.useMemo)(function () {
    return !!accounts.length ? accounts[0]['id'] : null;
  }, [accounts]);
}

function sellAmountValidate(values) {
  if (!values['sell-amount']) {
    return false;
  } else if (!/^\d+(\.\d{1,2})?$/.test(values['sell-amount'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['sell-amount']) <= 0) {
    return false;
  } else if (values['shop']['accounts'][values['sell-currency']]) {
    if (Number(values['sell-amount']) > Number(values['shop']['accounts'][values['sell-currency']]['available'])) {
      return false;
    }
  }

  return true;
}

function buyAmountValidate(values) {
  if (!values['buy-amount']) {
    return false;
  } else if (!/^(\d+)(\.\d{1,2})?$/.test(values['buy-amount'])) {
    // eslint-disable-next-line
    return false;
  } else if (Number(values['buy-amount']) <= 0) {
    return false;
  }

  return true;
}

function ModifyForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      pristine = _ref.pristine,
      shops = _ref.shops;

  try {
    var handleChangeFlag = function handleChangeFlag(direction) {
      setDirection(direction);
    };

    var handleChangeDescriptionFlag = function handleChangeDescriptionFlag() {
      var autoChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      dispatch((0, _reduxForm.change)('exchange-create', 'autoChange', autoChange));
    };

    var handleChangeShop = function handleChangeShop() {
      dispatch((0, _reduxForm.change)('exchange-create', 'sell-currency', defaultSellAccount));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var inProcess = (0, _reactRedux.useSelector)(_functionalButton.selectInSubmitProcess);
    var formData = (0, _reactRedux.useSelector)((0, _reduxForm.getFormValues)('exchange-create'));

    var _useState = (0, _react.useState)(SELL_DIRECTION),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        direction = _useState2[0],
        setDirection = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
        hasChanged = _useState4[0],
        setChanged = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
        calculateRate = _useState6[0],
        setCalculateRate = _useState6[1];

    var availableSellAccounts = (0, _useGetAvailableSellAccount["default"])(formData['shop']);
    var defaultSellAccount = useGetDefaultAccount(availableSellAccounts);
    var availableBuyAccounts = (0, _useGetAvailableBuyAccount["default"])(formData['sell-currency']);
    var defaultBuyAccount = useGetDefaultAccount(availableBuyAccounts);
    (0, _react.useEffect)(function () {
      if (formData['autoChange']) {
        return void 0;
      }

      var descriptionInitial = "\u041A\u043E\u043D\u0432\u0435\u0440\u0442\u0430\u0446\u0438\u044F \u0432\u0430\u043B\u044E\u0442\u044B ".concat(formData['sell-currency'], " \u0432 ").concat(formData['buy-currency']);
      dispatch((0, _reduxForm.change)('exchange-create', 'description', descriptionInitial));
    }, [formData['sell-currency'], formData['buy-currency']]);
    (0, _react.useEffect)(function () {
      dispatch((0, _reduxForm.change)('exchange-create', 'buy-currency', defaultBuyAccount, false));
    }, [defaultBuyAccount]);
    (0, _react.useEffect)(function () {
      function init() {
        return _init.apply(this, arguments);
      }

      function _init() {
        _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
          var _yield$dispatch, data;

          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (hasChanged) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", void 0);

                case 2:
                  if (formData['shop']) {
                    _context.next = 5;
                    break;
                  }

                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 5:
                  if (!(direction === BUY_DIRECTION)) {
                    _context.next = 12;
                    break;
                  }

                  if (buyAmountValidate(formData)) {
                    _context.next = 10;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('exchange-create', 'buy-amount', formData['buy-amount'], true));
                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 10:
                  _context.next = 17;
                  break;

                case 12:
                  if (!(direction === SELL_DIRECTION)) {
                    _context.next = 17;
                    break;
                  }

                  if (sellAmountValidate(formData)) {
                    _context.next = 17;
                    break;
                  }

                  dispatch((0, _reduxForm.blur)('exchange-create', 'sell-amount', formData['sell-amount'], true));
                  setChanged(false);
                  return _context.abrupt("return", void 0);

                case 17:
                  _context.prev = 17;
                  _context.next = 20;
                  return dispatch((0, _functionalButton.getExchangeAmount)(formData, direction === SELL_DIRECTION));

                case 20:
                  _yield$dispatch = _context.sent;
                  data = _yield$dispatch.data;

                  if (data) {
                    if (direction === BUY_DIRECTION) {
                      dispatch((0, _reduxForm.change)('exchange-create', 'sell-amount', String(data['from']['amount']), true));
                      dispatch((0, _reduxForm.change)('exchange-create', 'sign', data['sign']));
                      dispatch((0, _reduxForm.change)('exchange-create', 'date', data['date']));
                      dispatch((0, _reduxForm.focus)('exchange-create', 'buy-amount'));
                    } else if (direction === SELL_DIRECTION) {
                      dispatch((0, _reduxForm.change)('exchange-create', 'buy-amount', String(data['to']['amount']), true));
                      dispatch((0, _reduxForm.change)('exchange-create', 'sign', data['sign']));
                      dispatch((0, _reduxForm.change)('exchange-create', 'date', data['date']));
                      dispatch((0, _reduxForm.focus)('exchange-create', 'sell-amount'));
                    }

                    setCalculateRate(data);
                  }

                  _context.next = 28;
                  break;

                case 25:
                  _context.prev = 25;
                  _context.t0 = _context["catch"](17);
                  console.log('error', _context.t0);

                case 28:
                  setChanged(false);

                case 29:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[17, 25]]);
        }));
        return _init.apply(this, arguments);
      }

      init();
    }, [hasChanged, direction]);
    (0, _useDebouncedEffect.useDebouncedEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(direction !== SELL_DIRECTION)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return", void 0);

            case 2:
              setChanged(true);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })), 800, [formData['shop'], formData['sell-amount'], formData['sell-currency']]);
    (0, _useDebouncedEffect.useDebouncedEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(direction !== BUY_DIRECTION)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", void 0);

            case 2:
              setChanged(true);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })), 800, [formData['shop'], formData['buy-amount'], formData['buy-currency']]);
    return /*#__PURE__*/_react["default"].createElement("form", {
      className: _defaultModule["default"]['dialog'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Container, null, /*#__PURE__*/_react["default"].createElement(_storybook.Row, {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      label: 'Магазин',
      placeholder: 'Выбрать магазин',
      name: 'shop',
      optionKey: 'id',
      optionValue: 'name',
      options: shops,
      disabled: inProcess,
      clearable: false,
      simple: false,
      onChange: function onChange() {
        return handleChangeShop();
      }
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      label: 'Описание',
      name: 'description',
      className: _defaultModule["default"]['textarea'],
      disabled: inProcess,
      onFocus: function onFocus() {
        return handleChangeDescriptionFlag(true);
      }
    }))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, {
      className: (0, _classnames["default"])(_defaultModule["default"]['row'], _defaultModule["default"]['part'])
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__value']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      name: 'sell-amount',
      onFocus: function onFocus() {
        return handleChangeFlag(SELL_DIRECTION);
      },
      disabled: inProcess,
      label: 'Сумма продажи',
      autoFocus: true
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      name: 'sell-currency',
      placeholder: 'Валюта',
      clearable: false,
      optionKey: 'id',
      optionValue: 'value',
      options: availableSellAccounts,
      disabled: inProcess,
      onChange: function onChange() {
        return handleChangeFlag(SELL_DIRECTION);
      },
      label: 'Валюта'
    }))), formData['shop'] && formData['shop']['accounts'] && formData['shop']['accounts'][formData['sell-currency']] && formData['sell-currency'] && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['available']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment'
    }, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E: ", /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": 'Exchange.available.amount'
    }, (0, _numeral["default"])(formData['shop']['accounts'][formData['sell-currency']]['available']).format()), " ", /*#__PURE__*/_react["default"].createElement("span", {
      "data-locator": 'Exchange.available.currency'
    }, formData['sell-currency']))))), /*#__PURE__*/_react["default"].createElement(_storybook.Row, {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Col, null, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__value']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.InputField, {
      name: 'buy-amount',
      onFocus: function onFocus() {
        return handleChangeFlag(BUY_DIRECTION);
      },
      disabled: inProcess,
      label: 'Сумма покупки'
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['amount__currency']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.SelectField, {
      name: 'buy-currency',
      placeholder: 'Валюта',
      clearable: false,
      optionKey: 'id',
      optionValue: 'value',
      options: availableBuyAccounts,
      disabled: inProcess,
      onChange: function onChange() {
        return handleChangeFlag(BUY_DIRECTION);
      },
      label: 'Валюта'
    }))))), calculateRate && /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['rate']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 4
    }, "1 ".concat(calculateRate['from']['currency'], " = ").concat(calculateRate['exchangeRate'], " ").concat(calculateRate['to']['currency']))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'submit',
      type: 'submit',
      mode: 'success',
      inProcess: inProcess,
      disabled: !valid || pristine
    }, "\u041A\u043E\u043D\u0432\u0435\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

ModifyForm.defaultProps = {
  valid: false,
  pristine: true
};
var _default = ModifyForm;
exports["default"] = _default;